import { Component, OnInit } from '@angular/core';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { CRMService } from '../../services/crm.service';
import { UtilService } from '../../services/util.service';
import {
    ActionType
    , SearchCustomerAction
} from '../../models/models';

@Component({
    selector: 'crm-customer-actions',
    templateUrl: './crm-customer-actions.component.html',
    standalone: false
})
export class CrmCustomerActions implements OnInit {
    private repType: string = '';
    private employeeId: number = 0;
    private filter: string = '';

    public actionTypes: ActionType[] = [];
    public customerActionList: SearchCustomerAction[] = [];
    public view: GridDataResult = { data: [], total: 0 };
    public tmpView: GridDataResult = { data: [], total: 0 };
    public state: State = { skip: 0, take: 10 };
    public tmpState: State = {};
    public pageSizes: number[] = [5, 10, 20, 50, 100, 200, 500];
    public beginDate: Date = new Date();
    public endDate: Date = new Date();
    public actionTypeCards: Array<{ actionTypeDesc: string, total: number }> = [];

    constructor(private crmService: CRMService, private utilService: UtilService, private route: ActivatedRoute, public datePipe: DatePipe) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.repType = params.repType;
            this.employeeId = params.employeeId;
            this.filter = params.filter;

            this.getCustomerActionList();
        });

        this.getActionTypes();
    }

    private getActionTypes() {
        this.crmService.getActionTypes().subscribe(result => {
            this.actionTypes = result;
            this.actionTypes = this.actionTypes.filter(a => a.countTowardDailyActivity == true && a.retiredInd != true);
            for (var i = 0; i < this.actionTypes.length; i++) {
                this.actionTypeCards.push({
                    actionTypeDesc: this.actionTypes[i].actionTypeDescription,
                    total: 0
                });
            }
        });
    }

    private getCustomerActionList() {
        this.utilService.isLoading = true;
        this.crmService.getSearchCustomerActionByEmployeeTransactionDates(this.employeeId, this.beginDate, this.endDate).subscribe(result => {
            this.utilService.isLoading = false;
            this.customerActionList = result.resultCollection;
            this.setCustomerActionsGrid();
        });
    }

    private setCustomerActionsGrid() {
        if (this.state.sort) {
            this.customerActionList = orderBy(this.customerActionList, this.state.sort);
        }

        this.view = process(this.customerActionList, this.state);

        this.tmpState.filter = this.state.filter;
        this.tmpView = process(this.customerActionList, this.tmpState);

        for (var i = 0; i < this.actionTypeCards.length; i++) {
            this.actionTypeCards[i].total = this.tmpView.data.filter(t => t.actionTypeDescription == this.actionTypeCards[i].actionTypeDesc).length;
        }
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.state = state;
        this.setCustomerActionsGrid();
    }

    public onDateChange(value: Date) {
        this.getCustomerActionList();
    }
}
